import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { updateLocationTitle } from '../redux/contextInfos/contextInfosActions';
import { withRouter } from 'react-router-dom'

class LocationListener extends Component {
    constructor(props) {
        super(props);
        this.state = { title: '' }
    }

    componentDidMount() {
        this.handleLocationChange(this.props.history.location);
        this.unlisten = this.props.history.listen(this.handleLocationChange.bind(this));
    }

    componentWillUnmount() {
        this.unlisten();
    }

    handleLocationChange(location) {
        this.props.set_locationTitle(location.pathname);

        if (this.props.container && this.props.container.current)
            this.props.container.current.scrollTop = 0
    }

    render() {
        return this.props.children;
    }
}

LocationListener.contextTypes = {
    router: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        locationTitle: state.locationTitle
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        set_locationTitle: (locationTitle) => dispatch(updateLocationTitle(locationTitle))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationListener));
